import { render } from "./AppBreadcrumb.vue?vue&type=template&id=2a6a51f6"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js"

import "./AppBreadcrumb.vue?vue&type=style&index=0&id=2a6a51f6&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rlb-poc.prepare.servicedesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__